import React from 'react';
import { Box, IconButton, TablePagination } from '@material-ui/core';
import {
  LastPage,
  FirstPage,
  KeyboardArrowLeft,
  KeyboardArrowRight,
} from '@material-ui/icons';
import { useTheme } from '@material-ui/styles';
import { useIntl } from 'react-intl';

function TablePaginationActions({ count, page, onChangePage, rowsPerPage }) {
  const theme = useTheme();

  const handleFirstPageButtonClick = event => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = event => {
    onChangePage(event, (page - 1) * rowsPerPage);
  };

  const handleNextButtonClick = event => {
    onChangePage(event, (page + 1) * rowsPerPage);
  };

  const handleLastPageButtonClick = event => {
    onChangePage(
      event,
      Math.max(0, Math.ceil(count / rowsPerPage) - 1) * rowsPerPage
    );
  };

  return (
    <Box className="d-flex" sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPage /> : <FirstPage />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPage /> : <LastPage />}
      </IconButton>
    </Box>
  );
}

export default function Pagination(props) {
  const intl = useIntl();
  return (
    <TablePagination
      {...props}
      labelRowsPerPage={intl.formatMessage({ id: 'TABLE_PAGINATION' })}
      ActionsComponent={TablePaginationActions}
    />
  );
}
